import styled from 'styled-components';
import { Modal } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { Paragraph } from '@/components/Typography';

export const ModalWrapper = styled(Modal)`
	.ant-modal-content {
		padding: 30px 0;
		border-radius: 30px;
		min-width: 400px;
		max-width: 520px;
	}
`;

export const Description = styled(Paragraph)`
	font-size: 16px;
	font-weight: 400;
	line-height: 24px;
	letter-spacing: -0.5%;
	text-align: center;
`;

export const DeleteIcon = styled(DeleteOutlined)`
	color: #e74150;
	font-size: 3.5rem;
`;
